<app-loader *ngIf="!isDataReady"></app-loader>
<div class="ui-g" *ngIf="isDataReady">   
    <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
        <form [formGroup]="fullDescForm" (ngSubmit)="onSubmitFullDesc()">
            <span style="margin-top: 10px;">
                <span class="fixed-float-label">{{ 'full_desc' | translate}}</span>
                <textarea id="description-input" style="width: 100%;" [rows]="10"  pInputTextarea formControlName="description" name="description"></textarea>
            </span>

            <div *ngIf="isEditingFullDesc == false"> 
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onStartEditingFullDesc()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                </div>          
            </div> 
            <div class="ui-g" *ngIf="isEditingFullDesc == true">  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button pButton type="submit" [disabled]="!fullDescForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                </div>  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onCancelFullDesc()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                </div>                 
            </div>
        </form>
    </div> 

    <!-- <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
        <form [formGroup]="shortDescForm" (ngSubmit)="onSubmitShortDesc()">
            <span style="margin-top: 10px;">
                <span class="fixed-float-label">{{ 'short_desc' | translate}}</span>
                <textarea id="short_description-input" style="width: 100%;" [rows]="5"  pInputTextarea formControlName="short_description" name="short_description"></textarea>
            </span>

            <div *ngIf="isEditingShortDesc == false"> 
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onStartEditingShortDesc()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                </div>          
            </div> 
            <div class="ui-g" *ngIf="isEditingShortDesc == true">  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button pButton type="submit" [disabled]="!shortDescForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                </div>  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onCancelShortDesc()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                </div>                 
            </div>

        </form>
    </div>  -->

    <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
        <form [formGroup]="arrangerDetailsForm" (ngSubmit)="onSubmitArrangerDetails()">

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="pesel-input" formControlName="pesel" name="pesel" type="number" pInputText style="width: 100%;"> 
                <label for="pesel-input"> {{ 'pesel' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="tax_number-input" formControlName="tax_number" name="tax_number" type="number" pInputText style="width: 100%;"> 
                <label for="tax_number-input"> {{ 'tax_number' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="country-input" formControlName="country" name="country" type="text" pInputText style="width: 100%;"> 
                <label for="country-input"> {{ 'country' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="city-input" formControlName="city" name="city" type="text" pInputText style="width: 100%;"> 
                <label for="city-input"> {{ 'city' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="street-input" formControlName="street" name="street" type="text" pInputText style="width: 100%;"> 
                <label for="street-input"> {{ 'street' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="street_number-input" formControlName="street_number" name="street_number" type="text" pInputText style="width: 100%;"> 
                <label for="street_number-input"> {{ 'house_no' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="apartment_number-input" formControlName="apartment_number" name="apartment_number" type="text" pInputText style="width: 100%;"> 
                <label for="apartment_number-input"> {{ 'apart_no' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="postal_code-input" formControlName="postal_code" name="postal_code" type="text" pInputText style="width: 100%;"> 
                <label for="postal_code-input"> {{ 'postal_code' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <input id="bank_name-input" formControlName="bank_name" name="bank_name" type="text" pInputText style="width: 100%;"> 
                <label for="bank_name-input"> {{ 'bank_name' | translate}}</label>
            </span>

            <span class="ui-float-label" style="margin-top: 10px;">
                <input maxlength="50" id="account_number-input" formControlName="account_number" name="account_number" type="text" pInputText style="width: 100%;"> 
                <label for="account_number-input"> {{ 'bank_account' | translate}}</label>
            </span>

            <p-checkbox *ngIf="isAdmin" formControlName="b2b" [label]="'B2B'" [binary]="true"></p-checkbox>

            <div *ngIf="isEditingArrangerDetails == false"> 
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onStartEditingArrangerDetails()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                </div>          
            </div> 


            


            <div class="ui-g" *ngIf="isEditingArrangerDetails == true">  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button pButton type="submit"   label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                </div>  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onCancelArrangerDetails()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                </div>                 
            </div>

        </form>
    </div>
</div>